// extracted by mini-css-extract-plugin
export default {"action":"historyListPB_action__xEmEI","list":"historyListPB_list__oyw8r","divider":"historyListPB_divider__ap4md"};